export const ICONS_5 = [
  "16-arrow-bottom",
  "16-wrap",
  "16-nowrap",
  "16-wrap-reverse",
  "16-ai-action-white",
  "16-calendar-event",
  "16-bubble-wide-annotation-feedback",
  "16-people-added-new-member",
  "16-clock-alert-trial",
  "16-bubble-alert-payment",
  "16-gift",
  "16-shuffle-target-member",
  "16-star-lines-celebrate",
  "16-siren-re-engage",
  "16-bubbles-message",
  "16-calendar-clock-event",
  "16-heart-beat-engagement",
  "16-trending-circle-boost",
  "16-clipboard-feedback",
  "16-bubble-heart",
  "16-group-member",
  "16-tag-comment",
  "16-people-add-bulk",
  "16-square-behind-square-clone",
  "16-people-remove",
  "16-raising-hand-greet",
  "16-page-check-form",
  "16-target-arrow-tag",
  "16-credit-card",
  "16-hourglass",
  "16-coin-dollar",
  "16-thumbs-up-2",
  "16-trophy",
  "16-fork-code",
  "16-if-else-branch",
  "16-page-check",
  "16-rejected-comment",
  "16-square-arrow-top-right",
  "16-settings-gear",
  "20-user-add",
  "20-ai-filter",
  "12-ai-filter",
  "20-open-quote",
  "16-ai-rename",
  "16-lightning-filled",
  "16-branded-apps-builder-preview-circle",
  "24-builder-ui-element-line",
  "16-builder-ui-layers-chevron",
  "20-ai-prompt",
  "24-logo",
  "20-triangle-exclamation",
  "hw-help-submit-enabled-dark-mode",
  "hw-help-submit-disabled-dark-mode",
  "sw-help-submit-enabled",
  "sw-help-submit-disabled",
  "16-square-arrow-down",
  "20-visibility-visible",
  "20-visibility-hidden",
  "16-ai-send-dm",
  "24-layers-2",
  "24-layers-2-filled",
  "24-builder-element-grid",
  "24-builder-element-section",
  "16-alignment-left",
  "16-alignment-center",
  "16-alignment-right",
  "20-alignment-left",
  "20-alignment-center",
  "20-alignment-right",
  "16-settings-slider",
  "20-settings-slider",
  "visual-email-builder-dark",
  "visual-email-builder",
  "text-email-builder-dark",
  "text-email-builder",
  "12-play",
  "16-crown",
  "live-picture-in-picture",
  "64-picture-in-picture",
  "16-star-lines",
  "16-checklist",
  "16-rename",
  "copilot-chain-link",
  "20-chart",
  "20-tags",
  "20-no-tags",
  "16-brackets-2",
  "24-arrow-up",
  "24-arrow-down",
  "20-align-object-left",
  "20-align-object-center",
  "20-align-object-right",
  "20-zap",
  "16-hw-paperclip",
  "paywalls-card-amex",
  "paywalls-card-diners",
  "paywalls-card-discover",
  "paywalls-card-generic",
  "paywalls-card-jcb",
  "paywalls-card-mastercard",
  "paywalls-card-unionpay",
  "paywalls-card-visa",
  "paywalls-card-visa-v4",
  "paywalls-affirm",
  "paywalls-afterpay",
  "paywalls-apple-pay",
  "paywalls-bancontact",
  "paywalls-google-pay",
  "paywalls-ideal",
  "paywalls-klarna",
  "paywalls-link",
  "paywalls-link-badge",
  "paywalls-pix",
  "paywalls-sepa-debit",
  "billing-bank-account",
  "16-close-rounded",
  "16-blockquote",
  "20-arrow-up-down",
  "20-layout",
  "20-lock",
  "20-group",
  "20-globe-v2",
  "20-list",
  "20-cards",
  "live-pip-speaker-mode",
  "live-pip-gallery-mode",
  "20-hw-copilot-thinking-star",
  "24-builder-ui-element-short-answer",
  "24-builder-ui-element-long-answer",
  "24-builder-ui-element-single-choice",
  "24-builder-ui-element-multiple-choice",
  "24-builder-ui-element-dropdown",
  "24-builder-element-column",
  "24-builder-element-two-columns",
  "24-builder-element-three-columns",
  "24-builder-element-four-columns",
  "24-builder-element-2-1-columns",
  "24-builder-element-1-2-columns",
  "24-builder-element-1-2-1-columns",
  "24-builder-element-2-1-2-columns",
  "16-builder-display-block",
  "16-builder-display-flex-row",
  "16-builder-display-flex-column",
  "16-builder-display-grid",
  "16-builder-alignment-start",
  "16-builder-alignment-center",
  "16-builder-alignment-end",
  "16-builder-alignment-stretch",
  "16-builder-alignment-horizontal-start",
  "16-builder-alignment-horizontal-center",
  "16-builder-alignment-horizontal-end",
  "16-builder-alignment-horizontal-stretch",
  "20-eye-open",
  "20-dm-message",
  "16-magnifying-glass",
  "16-pin-location",
  "16-confetti",
  "16-online-users",
  "20-moderator",
  "20-block-dms",
  "16-block-dms",
  "16-circle-x",
  "16-warning",
  "apple-logo",
  "play-store-logo",
  "hw-copy",
  "hw-copied",
  "hw-up-vote",
  "hw-up-voted",
  "hw-down-vote",
  "hw-down-voted",
  "hw-sources",
  "shield-keyhole",
  "20-message-check",
  "24-forms-globe",
  "24-forms-chain-link",
  "16-add-to-basket",
  "20-trends",
  "16-people",
  "20-speaker",
  "20-circle-info",
  "32-checkmark",
  "32-checkmark-circle",
  "32-checkmark",
  "20-connections",
  "24-builder-ui-element-audio",
  "20-users-filled",
  "16-edit-post-settings",
  "20-pinned-speaker",
  "16-pinned-speaker",
  "32-admin-dash-audience",
  "32-admin-dash-broadcasts",
  "32-admin-dash-conversations",
  "32-admin-dash-courses",
  "32-admin-dash-posts",
  "32-admin-dash-rsvps",
  "32-admin-dash-payments",
  "32-admin-dash-website",
  "20-headphones",
  "32-arrow-path-down",
  "14-ai-features",
  "24-social-links",
  "20-camera-left-down",
  "20-camera-left-up",
  "20-camera-right-up",
  "20-camera-right-down",
  "16-colorwheel",
  "16-link-outline",
  "20-sidebar-trigger",
  "20-panel-trigger",
  "16-link-filled",
  "big-checkmark",
  "20-map",
  "32-circular-play",
  "20-filter-v2",
  "20-inbox-archived",
  "16-check-sm",
  "20-graduate-cap",
  "20-graduate-cap-hollow",
  "32-checkmark",
  "image-placeholder",
  "20-arrow-up",
  "16-open-letter",
  "16-click",
  "live-breakout-rooms",
  "20-accordion",
  "20-faq",
];
